import { render, staticRenderFns } from "./reportData.vue?vue&type=template&id=63ea0546&scoped=true"
import script from "./reportData.vue?vue&type=script&lang=js"
export * from "./reportData.vue?vue&type=script&lang=js"
import style0 from "./reportData.vue?vue&type=style&index=0&id=63ea0546&prod&lang=scss"
import style1 from "./reportData.vue?vue&type=style&index=1&id=63ea0546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ea0546",
  null
  
)

export default component.exports